interface LoadingProps {
    size?: 'sm' | 'md' | 'lg';
    text?: string;
    className?: string;
}

export default function Loading({ size = 'md', text, className = '' }: LoadingProps) {
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12'
    };

    return (
        <div className={`flex flex-col items-center justify-center gap-2 ${className}`}>
            <div
                className={`${sizeClasses[size]} border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin`}
            />
            {text && (
                <span className="text-sm text-gray-600 animate-pulse">
                    {text}
                </span>
            )}
        </div>
    );
}
